module.exports = __webpack_public_path__ + "static/media/icon-users.43d40311.svg";